export default {
  gapBetweenStackedColumns: 1
}
